module.exports = __webpack_public_path__ + "static/media/logo.fa3e3718.png";